import React, { useEffect, useState } from 'react';

// import SmallTile from './SmallTile';
import BigTile from './BigTile';

import { dbDateToTimestamp } from '../../utils/helpers';

const AgendaCard = ({
	movie,
	first,
	id,
	activeFilterDate,
	filterTags,
	serverTime,
	animationDelay,
	currentConfig,
	}) => {

  useEffect(() => {
    if ('date_range' in movie && movie.date_range[0]) {
      const date = dbDateToTimestamp(movie.date_range[0] + '0000');
      setReleaseDate(date);
    }
	});
	const [releaseDate, setReleaseDate] = useState('');

	useEffect(() => {
		if ('date_range' in movie && movie.date_range.release) {
			const date = dbDateToTimestamp(movie.date_range.release + '0000');
			setReleaseDate(date);
		}
	}, []);

	const handleTagClick = (value, onlyActivate) => {
		filterTags(value, onlyActivate);
	}

	if (currentConfig.agenda_tile_type === 'flint') {
		return (
			<BigTile
				movie={movie}
				showDate={first}
				id={id}
				activeFilterDate={activeFilterDate}
				serverTime={serverTime}
				animationDelay={animationDelay}
				currentConfig={currentConfig}
				releaseDate={releaseDate}
				handleTagClick={handleTagClick}
			/>
		);
	}

	if (currentConfig.agenda_tile_type === 'idea') {
		return (
			<BigTile
				movie={movie}
				showDate={true}
				id={id}
				activeFilterDate={activeFilterDate}
				serverTime={serverTime}
				animationDelay={animationDelay}
				currentConfig={currentConfig}
				releaseDate={releaseDate}
				handleTagClick={handleTagClick}
			/>
		);
	}

	return (
		<></>
	);

}

export default AgendaCard;
